import { c as compute_rest_props, s as subscribe, f as set_store_value } from "../../../../chunks/utils.js";
import { c as create_ssr_component, h as setContext, s as spread, b as escape_object, a as escape_attribute_value, v as validate_component, i as each, e as escape, m as missing_component } from "../../../../chunks/ssr.js";
import { w as writable } from "../../../../chunks/index2.js";
import { T as Toggle } from "../../../../chunks/Toggle.js";
import { H as Heading } from "../../../../chunks/Heading.js";
import { A as Avatar } from "../../../../chunks/Avatar.js";
import { C as CopyToClipboard } from "../../../../chunks/CopyToClipboard.js";
import { S as Steps } from "../../../../chunks/Steps.js";
import { I as InfoBox } from "../../../../chunks/InfoBox.js";
import { S as SearchFilter } from "../../../../chunks/SearchFilter.js";
import { T as Typeahead } from "../../../../chunks/Typeahead.js";
import { P as Pagination } from "../../../../chunks/Pagination.js";
import { V as VerticalGrid, E as EmployeeInfo, Q as Qualifications, T as TaxAndInsurance, B as BankAccount } from "../../../../chunks/TaxAndInsurance.js";
import { S as SortableTable } from "../../../../chunks/SortableTable.js";
import { F as FileDrop } from "../../../../chunks/FileDrop.js";
import { B as Button } from "../../../../chunks/Button.js";
import { twMerge } from "tailwind-merge";
import { M as Modal } from "../../../../chunks/Modal2.js";
import { g as globalConfirm } from "../../../../chunks/modal.js";
import { g as globalToast } from "../../../../chunks/toast2.js";
import { C as CardLayout } from "../../../../chunks/CardLayout.js";
import dayjs from "dayjs";
import { a as asValue } from "../../../../chunks/lenkradDate.js";
import { G as GeneralInfo, P as Photos, R as Reminder, T as Timeline, a as TimelineItem } from "../../../../chunks/Photos.js";
import { C as ClipboardSolid, F as FolderSolid, M as MessagesSolid, I as InfoCircleOutline, E as EmploymentStatus } from "../../../../chunks/EmploymentStatus.js";
import { T as TicketOutline, E as EditSolid, a as TabButton } from "../../../../chunks/TabButton.js";
import { E as ExclamationCircleSolid } from "../../../../chunks/ExclamationCircleSolid.js";
import { G as GridOutline } from "../../../../chunks/GridOutline.js";
import { I as IconSolid } from "../../../../chunks/IconSolid.js";
import { I as InfoCircleSolid } from "../../../../chunks/InfoCircleSolid.js";
import { L as ListOutline } from "../../../../chunks/ListOutline.js";
import { P as PenOutline } from "../../../../chunks/PenOutline.js";
import { U as UserSolid } from "../../../../chunks/UserSolid.js";
import { T as Textarea } from "../../../../chunks/Textarea.js";
import { T as Tooltip } from "../../../../chunks/Tooltip.js";
import "../../../../chunks/api.js";
import { E as EmployeeAvatar } from "../../../../chunks/EmployeeAvatar.js";
import { p as page } from "../../../../chunks/stores.js";
import { l as listView } from "../../../../chunks/viewStore.js";
const globals = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : (
  // @ts-ignore Node typings have this
  global
);
const ButtonGroup = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "divClass"]);
  let { size = "md" } = $$props;
  let { divClass = "inline-flex rounded-lg shadow-sm" } = $$props;
  setContext("group", { size });
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.divClass === void 0 && $$bindings.divClass && divClass !== void 0) $$bindings.divClass(divClass);
  return `<div${spread(
    [
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge(divClass, $$props.class))
      },
      { role: "group" }
    ],
    {}
  )}>${slots.default ? slots.default({}) : ``}</div> `;
});
const ModalPreview = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $globalToast, $$unsubscribe_globalToast;
  let $$unsubscribe_globalConfirm;
  $$unsubscribe_globalToast = subscribe(globalToast, (value) => $globalToast = value);
  $$unsubscribe_globalConfirm = subscribe(globalConfirm, (value) => value);
  let showModal = false;
  set_store_value(globalToast, $globalToast.color = "green", $globalToast);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(ButtonGroup, "ButtonGroup").$$render($$result, {}, {}, {
      default: () => {
        return `${validate_component(Button, "Button").$$render($$result, {}, {}, {
          default: () => {
            return `Confirm`;
          }
        })} ${validate_component(Button, "Button").$$render($$result, {}, {}, {
          default: () => {
            return `Toast`;
          }
        })} ${validate_component(Button, "Button").$$render($$result, {}, {}, {
          default: () => {
            return `Modal`;
          }
        })}`;
      }
    })} ${validate_component(Modal, "Modal").$$render(
      $$result,
      { title: "Demomodal", open: showModal },
      {
        open: ($$value) => {
          showModal = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `Modal`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_globalToast();
  $$unsubscribe_globalConfirm();
  return $$rendered;
});
const Tabs = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { tabs } = $$props;
  let { activeTab } = $$props;
  if ($$props.tabs === void 0 && $$bindings.tabs && tabs !== void 0) $$bindings.tabs(tabs);
  if ($$props.activeTab === void 0 && $$bindings.activeTab && activeTab !== void 0) $$bindings.activeTab(activeTab);
  return `<div class="mb-5"><div class="block"><div class="border-b border-gray-200"><nav class="-mb-px w-full flex" aria-label="Tabs">${each(tabs, (tab, index) => {
    return `<div class="${escape(
      activeTab === index ? "border-primary-500 text-primary-600" : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700",
      true
    ) + " flex-1 border-b-2 py-4 px-1 text-center text-sm font-medium cursor-pointer"}">${escape(tab)} </div>`;
  })}</nav></div></div></div>`;
});
const VerticalGridPreview = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  return `${validate_component(VerticalGrid, "VerticalGrid").$$render($$result, {}, {}, {
    right: () => {
      return `${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          title: "slot",
          value: "right",
          slot: "right"
        },
        {},
        {}
      )}`;
    },
    default: () => {
      return `${validate_component(InfoBox, "InfoBox").$$render($$result, { title: "slot", value: "left" }, {}, {})}`;
    }
  })}`;
});
const Ldw1 = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $employee, $$unsubscribe_employee;
  let $page, $$unsubscribe_page;
  let $listView, $$unsubscribe_listView;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  $$unsubscribe_listView = subscribe(listView, (value) => $listView = value);
  let employee = writable();
  $$unsubscribe_employee = subscribe(employee, (value) => $employee = value);
  setContext("employee", employee);
  let trigger_submits = writable(/* @__PURE__ */ new Set());
  setContext("trigger_submits", trigger_submits);
  const ICONS = [
    {
      type: "info",
      icon: InfoCircleSolid,
      color: "bg-primary-200 text-primary-600"
    },
    {
      type: "important",
      icon: ExclamationCircleSolid,
      color: "bg-red-200 text-red-600"
    }
  ];
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${$employee?.id ? `<div class="flex flex-col md:flex-row items-start gap-3 px-4 pt-7"><div class="flex flex-1 flex-row items-center gap-3">${validate_component(EmployeeAvatar, "EmployeeAvatar").$$render($$result, { employee: $employee, size: "2xl" }, {}, {})} <div class="flex flex-col items-start gap-1"><h1 class="text-base text-neutral-600 sm:text-lg md:text-2xl font-bold">${escape($employee.name)}</h1> <span class="text-neutral-600" data-svelte-h="svelte-1ox8jik">Unit: Demo Unit</span> <div class="text-neutral-600 text-[14px] flex gap-2">${validate_component(TicketOutline, "TicketOutline").$$render($$result, { class: "text-primary-400 " }, {}, {})} <span>${escape($employee.employeeNumber || "Bewerber")}</span></div></div></div> <div class="flex gap-3 mb-2">${validate_component(Button, "Button").$$render($$result, { size: "xs", icon: EditSolid }, {}, {
      default: () => {
        return `${validate_component(PenOutline, "PenOutline").$$render($$result, { class: "w-4 mr-2" }, {}, {})} <span data-svelte-h="svelte-1gcijcp">Button 1</span>`;
      }
    })} ${validate_component(Button, "Button").$$render($$result, { size: "xs", icon: EditSolid }, {}, {
      default: () => {
        return `${validate_component(PenOutline, "PenOutline").$$render($$result, { class: "w-4 mr-2" }, {}, {})} <span data-svelte-h="svelte-s78edc">Button 2</span>`;
      }
    })}</div></div> <div class="flex flex-row items-end justify-between w-full md:border-b border-gray-300 mt-5"><div class="flex flex-wrap md:flex-nowrap flex-row justify-start items-center gap-3 md:gap-0">${validate_component(TabButton, "TabButton").$$render(
      $$result,
      {
        href: "/employee/" + $page.params.uuid,
        icon: UserSolid,
        title: "Stammdaten"
      },
      {},
      {}
    )} ${validate_component(TabButton, "TabButton").$$render(
      $$result,
      {
        href: "/employee/" + $page.params.uuid + "/vertrag",
        icon: ClipboardSolid,
        title: "Vertrag / Gehalt"
      },
      {},
      {}
    )} ${validate_component(TabButton, "TabButton").$$render(
      $$result,
      {
        href: "/employee/" + $page.params.uuid + "/dokumente",
        icon: FolderSolid,
        title: "Dokumente"
      },
      {},
      {}
    )} ${$employee.userId ? `${validate_component(TabButton, "TabButton").$$render(
      $$result,
      {
        href: "/employee/" + $page.params.uuid + "/connect",
        icon: MessagesSolid,
        title: "Connect"
      },
      {},
      {}
    )}` : ``}</div> <div class="max-w-sm w-full pl-[1.1rem] flex justify-between"><div class="h-[50px] flex gap-1 items-center"><div class="text-neutral-600 dark:text-gray-400 whitespace-nowrap relative">${validate_component(InfoCircleOutline, "InfoCircleOutline").$$render($$result, { class: "text-primary-400" }, {}, {})}</div> <div>${validate_component(EmploymentStatus, "EmploymentStatus").$$render(
      $$result,
      {
        size: "sm",
        uuid: $employee.uuid,
        status: $employee.employmentStatus
      },
      {
        status: ($$value) => {
          $employee.employmentStatus = $$value;
          $$settled = false;
        }
      },
      {}
    )}</div></div> <div class="pr-3 pt-1">${validate_component(Button, "Button").$$render(
      $$result,
      {
        color: "alternative",
        pill: true,
        class: "!p-2"
      },
      {},
      {
        default: () => {
          return `${$listView ? `${validate_component(ListOutline, "ListOutline").$$render($$result, { class: "text-primary-600" }, {}, {})}` : `${validate_component(GridOutline, "GridOutline").$$render($$result, { class: "text-primary-600" }, {}, {})}`}`;
        }
      }
    )} ${validate_component(Tooltip, "Tooltip").$$render($$result, {}, {}, {
      default: () => {
        return `Ansicht wechseln`;
      }
    })}</div></div></div> <div class="pt-12 px-0"><div class="flex flex-col lg:flex-row gap-3"><div class="flex flex-col gap-7 xl:max-w-sm">${validate_component(GeneralInfo, "GeneralInfo").$$render($$result, { employee: $employee }, {}, {})} ${validate_component(CardLayout, "CardLayout").$$render(
      $$result,
      {
        title: $employee.employmentStatus !== "active" ? "Ich will ins Team weil..." : "Notiz",
        className: "sticky top-24"
      },
      {},
      {
        default: () => {
          return `${validate_component(Textarea, "Textarea").$$render(
            $$result,
            {
              disabled: true,
              rows: "4",
              value: $employee?.cv?.note
            },
            {},
            {}
          )}`;
        }
      }
    )} ${validate_component(Photos, "Photos").$$render($$result, { employee: $employee }, {}, {})}</div> <div class="flex flex-col 2xl:flex-row gap-3 w-full"><div class="flex flex-col w-full gap-7">${validate_component(Reminder, "Reminder").$$render($$result, {}, {}, {})} ${validate_component(EmployeeInfo, "EmployeeInfo").$$render($$result, {}, {}, {})} ${validate_component(Qualifications, "Qualifications").$$render($$result, {}, {}, {})} ${validate_component(TaxAndInsurance, "TaxAndInsurance").$$render($$result, {}, {}, {})} ${validate_component(BankAccount, "BankAccount").$$render($$result, {}, {}, {})}</div> <div class="max-w-sm w-full">${validate_component(CardLayout, "CardLayout").$$render(
      $$result,
      {
        display: false,
        className: "mb-4",
        title: "Add to Timeline",
        accordion: true
      },
      {},
      {
        default: () => {
          return `<form class="mb-7 flex flex-col gap-2" method="post" action="?/publish_to_timeline">${validate_component(Textarea, "Textarea").$$render(
            $$result,
            {
              id: "textarea-id",
              placeholder: "Your message",
              rows: "4",
              name: "content"
            },
            {},
            {}
          )} ${validate_component(Button, "Button").$$render(
            $$result,
            {
              type: "submit",
              class: "ml-auto",
              variant: "primary"
            },
            {},
            {
              default: () => {
                return `Add work log`;
              }
            }
          )}</form>`;
        }
      }
    )} <div class="px-7 mt-8">${validate_component(Timeline, "Timeline").$$render($$result, { order: "vertical", class: "w-full" }, {}, {
      default: () => {
        return `${each($employee.timeline.sort((a, b) => b.createdAt.stamp - a.createdAt.stamp), (timelineItem) => {
          let icon = ICONS.find((x) => x.type === timelineItem.type);
          return ` ${validate_component(TimelineItem, "TimelineItem").$$render(
            $$result,
            {
              title: timelineItem.type,
              date: dayjs(asValue(timelineItem.createdAt)).format("DD.MM.YYYY HH:mm")
            },
            {},
            {
              icon: () => {
                return `<span class="${"flex absolute -left-3 justify-center items-center w-6 h-6 " + escape(icon?.color, true) + " rounded-full ring-8 ring-white"}">${validate_component(IconSolid, "IconSolid").$$render($$result, { icon: icon?.icon, class: "w-3 h-3 " }, {}, {})}</span> `;
              },
              default: () => {
                return `<p class="text-gray-400 my- text-xs">${timelineItem.enteringEmployeeId ? `${escape(timelineItem?.enteringAssociations[0]?.firstName + " " + timelineItem?.enteringAssociations[0]?.lastName)}` : `System`}</p> <div class="mb-4 text-base font-normal text-gray-500 overflow-x-auto"><!-- HTML_TAG_START -->${timelineItem.content}<!-- HTML_TAG_END --></div> `;
              }
            }
          )}`;
        })}`;
      }
    })}</div></div></div></div></div>` : ``}`;
  } while (!$$settled);
  $$unsubscribe_employee();
  $$unsubscribe_page();
  $$unsubscribe_listView();
  return $$rendered;
});
const { Object: Object_1 } = globals;
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $editMode, $$unsubscribe_editMode;
  const editMode = writable(false);
  $$unsubscribe_editMode = subscribe(editMode, (value) => $editMode = value);
  const components = {
    layout: [{ name: "LDW1", component: Ldw1 }],
    display: [
      {
        name: "$store / Modal",
        component: ModalPreview,
        props: { super_edit: editMode }
      },
      {
        name: "lib/components/Avatar",
        component: Avatar,
        props: {
          associate: { firstName: "John", lastName: "Doe" }
        }
      },
      {
        name: "lib/components/CopyToClipboard",
        component: CopyToClipboard,
        props: { textToCopy: "test" }
      },
      {
        name: "lib/components/Steps",
        component: Steps,
        props: {
          steps: [{ label: "Step 1", route: "/ui" }, { label: "Step 2", route: "/ui" }]
        }
      },
      {
        name: "lib/components/Tabs",
        component: Tabs,
        props: { tabs: ["Tab 1", "Tab 2"], activeTab: 0 }
      }
    ],
    content: [
      {
        name: "lib/components/Pagination",
        component: Pagination,
        props: { pagination: { pages: 3, page: 1 } }
      },
      {
        name: "lib/components/VerticalGrid",
        component: VerticalGridPreview,
        props: {}
      },
      {
        name: "lib/components/SortableTable",
        component: SortableTable,
        props: {
          data: [{ name: "test 1", id: 1 }, { name: "test 2", id: 2 }],
          header: [
            {
              label: "Name",
              property: "name",
              sortable: true
            },
            { label: "ID", property: "id" }
          ]
        }
      },
      {
        name: "items/CardLayout",
        component: CardLayout,
        props: { title: "Card / Box", accordion: true }
      }
    ],
    input: [
      {
        name: "lib/items/InfoBox",
        component: InfoBox,
        props: {
          title: "Label",
          value: "Value",
          super_edit: editMode
        }
      },
      {
        name: "lib/components/SearchFilter",
        component: SearchFilter,
        props: { super_edit: editMode }
      },
      {
        name: "lib/components/Typeahead",
        component: Typeahead,
        props: {
          data: [{ name: "test 1" }, { name: "test 2" }]
        }
      },
      {
        name: "lib/components/FileDrop",
        component: FileDrop,
        props: {}
      }
    ]
  };
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `<div class="flex gap-3"><div class="px-5 mt-5">${validate_component(Toggle, "Toggle").$$render(
      $$result,
      { class: "my-3", checked: $editMode },
      {
        checked: ($$value) => {
          $editMode = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `Editing`;
        }
      }
    )}</div> <div class="my-5 w-4/5 mx-auto">${validate_component(Heading, "Heading").$$render($$result, { tag: "h1", class: "text-neutral-600" }, {}, {
      default: () => {
        return `UI`;
      }
    })} <p data-svelte-h="svelte-1t10fuy">General: <a target="_blank" class="text-primary-700 hover:text-primary-600" href="https://flowbite-svelte.com/docs/components/accordion">Flowbite</a></p> ${each(Object.entries(components), ([category, items]) => {
      return `${validate_component(Heading, "Heading").$$render(
        $$result,
        {
          tag: "h2",
          class: "text-neutral-600 mt-6"
        },
        {},
        {
          default: () => {
            return `${escape(category.toUpperCase())}`;
          }
        }
      )} <div class="grid gap-3 my-3">${each(items, (component) => {
        return `<div class="border rounded border-neutral-100 shadow p-5 flex flex-col"><p class="text-neutral-600"><a target="_blank" href="${"https://github.com/recrew/retech.rest/tree/master/apps/portal/src/" + escape(component.name, true) + ".svelte"}">${escape(component.name)}</a></p> <div class="flex-1">${validate_component(component.component || missing_component, "svelte:component").$$render($$result, Object_1.assign({}, component.props), {}, {})}</div> </div>`;
      })} </div>`;
    })}</div></div>`;
  } while (!$$settled);
  $$unsubscribe_editMode();
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
